// import React, { useState } from "react";
// import {
//   Button,
//   Divider,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../../../components";
// import { dateFormator, mapTableRows } from "../../../../../utils";
// import { avaitingAprrovalTableData } from "../../../../../assets/data/candidatesData";

// const ViewApprovals = () => {
//   const [collapseOne, setCollapseOne] = useState(false);
//   const [collapseTwo, setCollapseTwo] = useState(false);
//   const [collapseThree, setCollapseThree] = useState(false);

//   const handleOpenOne = () => {
//     setCollapseOne(!collapseOne);
//   };
//   const handleOpenTwo = () => {
//     setCollapseTwo(!collapseTwo);
//   };
//   const handleOpenThree = () => {
//     setCollapseThree(!collapseThree);
//   };

//   const tableData = avaitingAprrovalTableData;
//   const columns = [
//     {
//       key: "month",
//       label: "Month",
//       render: (row) => dateFormator(row.month, "shortMonthYear"),
//     },
//     {
//       key: "totalHours",
//       label: "Total Hours",
//       sortable: true,
//     },
//     {
//       key: "missingDates",
//       label: "Missing Dates",
//     },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);

//   return (
//     <div className="border-[1px] border-neutrals-50 rounded px-4">
//       <div className="mt-3">
//         <PageHeader
//           Section={
//             <div className="flex">
//               <PageTitle title={" Awaiting invoices"} tag="p" />
//             </div>
//           }
//           RightSection={
//             <>
//               <Button
//                 type={"icon"}
//                 title="Back"
//                 size="sm"
//                 icon={"close"}
//                 // onClick={() => window.history.back()}
//                 variant="text"
//                 color="black"
//               />
//             </>
//           }
//         />
//         <Divider />
//       </div>
//       <div className="mt-6">
//         <div className="">
//           <div
//             className="bg-primary text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 body-two"
//             onClick={() => handleOpenOne()}
//           >
//             <span
//               className={`material-symbols-rounded -rotate-90 ${
//                 collapseOne ? "rotate-0 " : ""
//               }`}
//             >
//               stat_minus_1
//             </span>
//             L&T Technologies Ltd
//           </div>
//           {collapseOne && (
//             <div>
//               <div
//                 className="bg-black text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 ml-8 mt-2 body-two"
//                 onClick={() => handleOpenTwo()}
//               >
//                 <span
//                   className={`material-symbols-rounded -rotate-90 ${
//                     collapseTwo ? "rotate-0 " : ""
//                   }`}
//                 >
//                   stat_minus_1
//                 </span>
//                 Mohammed Karamat
//               </div>
//             </div>
//           )}
//           {collapseTwo && (
//             <div>
//               <div
//                 className="bg-black text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 ml-12 mt-2 body-two"
//                 onClick={() => handleOpenThree()}
//               >
//                 <span
//                   className={`material-symbols-rounded -rotate-90 ${
//                     collapseThree ? "rotate-0 " : ""
//                   }`}
//                 >
//                   stat_minus_1
//                 </span>
//                 Dev
//               </div>
//             </div>
//           )}
//           {collapseThree && (
//             <div className="ml-16 my-2 ">
//               <div>
//                 <NewTable rows={mappedRows} columns={columns} hideToolBar />
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewApprovals;

import React, { useState } from "react";
import {
  CollapsibleSections,
  Divider,
  PageHeader,
  PageTitle,
} from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";

const ViewApprovals = () => {
  const invoiceSectionsData = [
    {
      id: "lt-tech",
      title: "L&T Technologies Ltd",
      children: [
        {
          id: "mohammed",
          title: "Mohammed Karamat",
          children: [
            {
              id: "dev",
              title: "Dev",
              tableData: {
                rows: mapTableRows(
                  [
                    {
                      id: 1,
                      month: "2020-04-01",
                      totalHours: 24,
                      missingDates: "Apr 2020: 01, 02, 03",
                    },
                    {
                      id: 2,
                      month: "2020-05-01",
                      totalHours: 176,
                      missingDates:
                        "May 2020: 01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31",
                    },
                  ],
                  [
                    {
                      key: "month",
                      label: "Month",
                      render: (row) =>
                        dateFormator(row.month, "shortMonthYear"),
                    },
                    {
                      key: "totalHours",
                      label: "Total Hours",
                      sortable: true,
                    },
                    {
                      key: "missingDates",
                      label: "Missing Dates",
                    },
                  ]
                ),
                columns: [
                  {
                    key: "month",
                    label: "Month",
                  },
                  {
                    key: "totalHours",
                    label: "Total Hours",
                    sortable: true,
                  },
                  {
                    key: "missingDates",
                    label: "Missing Dates",
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ];

  const timesheetSectionsData = [
    {
      id: "tekishub",
      title: "Tekishub",
      children: [
        {
          id: "sarah",
          title: "Sarah Johnson",
          children: [
            {
              id: "qa",
              title: "QA",
              tableData: {
                rows: mapTableRows(
                  [
                    {
                      id: 1,
                      weekEnding: "2023-04-28",
                      regular: 40,
                      overtime: 5,
                      status: "Submitted",
                    },
                    {
                      id: 2,
                      weekEnding: "2023-05-05",
                      regular: 35,
                      overtime: 0,
                      status: "Draft",
                    },
                  ],
                  [
                    {
                      key: "weekEnding",
                      label: "Week Ending",
                    },
                    {
                      key: "regular",
                      label: "Regular Hours",
                    },
                    {
                      key: "overtime",
                      label: "Overtime",
                    },
                    {
                      key: "status",
                      label: "Status",
                    },
                  ]
                ),
                columns: [
                  {
                    key: "weekEnding",
                    label: "Week Ending",
                  },
                  {
                    key: "regularHours",
                    label: "Regular Hours",
                  },
                  {
                    key: "overtime",
                    label: "Overtime",
                  },
                  {
                    key: "status",
                    label: "Status",
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className="border-[1px] border-neutrals-50 rounded px-4">
      <div className="mt-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={" Awaiting invoices"} tag="p" />
            </div>
          }
        />
        <Divider />
      </div>
      <CollapsibleSections sectionsData={invoiceSectionsData} />
      <CollapsibleSections sectionsData={timesheetSectionsData} />
      <CollapsibleSections sectionsData={invoiceSectionsData} />
      <CollapsibleSections sectionsData={timesheetSectionsData} />
    </div>
  );
};

export default ViewApprovals;
